import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Socios_Modal from './socios_modal';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';


const database=firebase.database();



const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };



class Socios extends Component {
    constructor(props) {
    super(props);
    this.state = {
    socios: [],
	  isActive:false,
	  keyRow:'',
	  nombre:'',
	  apellido:'',
	  estado:'',
	  estadoSocio:'',
	  template:false

    };
  //this is connect to the firebase
   this.SociosRef = database.ref().child('Socios');
   this.vehiculosRef=database.ref().child('Vehiculos');
   this.empleadosRef=database.ref().child('Empleados');
   this.updateRow=this.updateRow.bind(this);
   this.ocultarMenu=this.ocultarMenu.bind(this);
   
   this.handleChangeSelect=this.handleChangeSelect.bind(this);
   this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
   this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
   this.handleClickAlerta=this.handleClickAlerta.bind(this);
   this.handleClickClose=this.handleClickClose.bind(this);
   
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
   
  }
  
  
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas realizar este cambio de estado en el socio? , podria perjudicar todos los vehiculos y trabajadores asignados a este', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
  
  
	handleClickClose(){		
		Alert.closeAll();
	}
  
  
   componentWillMount(){
   Modal.setAppElement('body');
  }

  //After the connect, what the state will do--gotdata
  componentDidMount() {
    this.SociosRef.on('value', this.gotData, this.errData);
  }
  //get the data from the firebase and push them out
  gotData = (data) => {
	  let newsocios = []
	  if(data.val()!==null){
      const sociosdata = data.val();
      const keys = Object.keys(sociosdata);

      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];

		
		
        newsocios.push({
          key:k,
		  nombre:sociosdata[k].Nombre,
		  apellido:sociosdata[k].Apellido,
		  estado:sociosdata[k].Estado,
		  correo:sociosdata[k].correo


        });
      }
	  this.setState({Socios: newsocios});
	}
    }
    errData = (err) => {
  console.log(err);
}

 handleClick = (rowKey) => {
  
   
   this.setState({
	   keyRow:rowKey.key,
	   nombre:rowKey.nombre,
	   apellido:rowKey.apellido,
	   estado:rowKey.estado,
	   correo:rowKey.correo
   });



   this.toggleModalUpdate();
 }

  handleChange = (e) => {
	this.setState({inputValue: e.target.value});
  }
  
  handleChangeSelect(){
	  
	  this.state.estadoSocio=this.estadosocios.value;
	  
	  
  }

 	toggleModalUpdate=()=>{

		this.setState({

			isActive:!this.state.isActive
		})
	}

	updateRow=()=>{

		let nodoHijo=this.keyRow.value;


		this.setState({
			
			estadoSocio:this.estadosocios.value
			
		})
		
		

		this.SociosRef.child(nodoHijo).update({
			Nombre:this.nombresocios.value,
			Apellido:this.apellidosocios.value,
			Estado:this.estadosocios.value
		});
		
		
			
			this.vehiculosRef.orderByChild('codigo_socio').equalTo(nodoHijo).on('value',this.gotDataVehiculos,this.errDataVehiculos);
			
			this.empleadosRef.orderByChild('socio').equalTo(nodoHijo).on('value',this.gotDataEmpleados,this.errDataEmpleados);
		
		
		
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
	    });
		this.toggleModalUpdate();

	}

	
	gotDataVehiculos = (data) => {
		
			const vehiculodata = data.val();
		  
			if(vehiculodata!=null){
				
				const keys = Object.keys(vehiculodata);
			
				const estadoVehiculos=(this.state.estadoSocio==='Activo')?'Disponible':'Inactivo';
				
				
				  for (let i = 0; i < keys.length; i++) {
					const k = keys[i];
							
							database.ref().child('Vehiculos').child(k).update({
								
								estado:estadoVehiculos
								
							})
					
					
				  }
				
			}
		  

			
		}
		errDataVehiculos = (err) => {
	      console.log(err);
	    }
	
	
	
	
	    gotDataEmpleados = (data) => {
		
		 
			const empleadosdata = data.val();
		  
			if(empleadosdata!=null){
			
				const keys = Object.keys(empleadosdata);
			
			const estadoEmpleados=(this.state.estadoSocio==='Activo')?'activo':'desactivo';
			
			  
				
			  for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
						
					
					database.ref().child('Empleados').child(k).update({
						
						estado:estadoEmpleados
						
					})
								
			 }
			
		  
				
				
			}
		  
		  
			
		  
		}
		errDataEmpleados = (err) => {
	      console.log(err);
	    }

	imgFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	
	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}
	
	handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}
	
	ocultarMenu(){
		
		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
		
	}
	
	

 render(){

   return (
<div className="container"  onClick={this.ocultarMenu} >
       <div >
			  <h1 className="titulo">Socios</h1>

			  </div>

    
	     	 <Socios_Modal/>
			 {this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}

			 <BootstrapTable data={ this.state.Socios}
				 ref='table'
				 pagination={ true }
				 search={ true }
				 hover
				 >
				 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				 <TableHeaderColumn dataField='nombre' dataSort={true}>Nombre</TableHeaderColumn>
				 <TableHeaderColumn dataField='apellido' dataSort={true}>Apellido</TableHeaderColumn>
				 <TableHeaderColumn dataField='correo' dataSort={true}>Correo</TableHeaderColumn>
				 <TableHeaderColumn dataField='estado'>Estado</TableHeaderColumn>
				 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
			  </BootstrapTable>

			 	<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>

						
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
				
								<h3>Modificar Socio</h3>
								<hr/>
								<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
								<div className="form-group">
										<label htmlFor="nombre" >Nombre:</label>
										<input type="text" className="form-control" name="nombre" 
											ref={input => {this.nombresocios=input;}}
											onKeyPress={this.handleKeyPressLetras}
											required autoComplete="off"
											placeholder="Nombre"
										defaultValue={this.state.nombre}
										/>
									</div>
									<div className="form-group">
										<label htmlFor="apellido" >Apellido:</label>
										<input type="text" className="form-control" name="apellido"
											ref={input => {this.apellidosocios=input;}}
											onKeyPress={this.handleKeyPressLetras}
											required autoComplete="off"
											placeholder="Apellido"
										defaultValue={this.state.apellido}
										/>
									</div>
									<div className="form-group">
										<label htmlFor="correo">Correo</label>
										<input type="email" className="form-control" name="correo"
											value={this.state.correo} disabled="disabled"
										
										/>
									</div>
									
									<div className="form-group">
										<label htmlFor="estado" >estado:</label>
										
										<select name="estado" defaultValue={this.state.estado} onChange={this.handleChangeSelect}
											ref={input => {this.estadosocios=input;}}
											defaultValue={this.state.estado}
											className="form-control"
										>
										<option>Activo</option>
										<option>Inactivo</option>
										
										</select>
										
									</div>

								<hr/>
								<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
								<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
						
						
					</Modal>



     </div>
   );
  }
 }


export default Socios;



// WEBPACK FOOTER //
// ./src/Components/Socios/Socios.jsx